import React, { useEffect } from 'react';
import { Button, Form, Input, Card, Select, Table, Row, DatePicker, Popconfirm, Badge } from 'antd';
import { services } from '@comall-backend-builder/core';
import './index.less';
import { errorHandle } from '../../services';
const { Option } = Select;
const { RangePicker } = DatePicker;

const api = services.api;
const confirmProps = {
    title: '确定要删除吗？',
    okText: '确定',
    cancelText: '取消',
};
export interface LabelRuleListViewProps {
    form: any;
}

export interface IState {
    visible: boolean;
    black_remark: string;
    visibleClear: boolean;
    clearType: boolean;
    productModal: {
        visible: boolean;
        type: string;
    };
}

// 商品经营管理
const LabelRuleListView = ({ form }: LabelRuleListViewProps) => {
    const [categoryCodeOptions, setCategoryCodeOptions] = React.useState([]);
    const [pageSize, setPageSize] = React.useState(10);
    const [pageNum, setPageNum] = React.useState(1);
    const [total, setTotal] = React.useState(0);
    const [tableData, setTableData] = React.useState([]);
    const [searchParams, setSearchParams] = React.useState({});
    const columns = [
        {
            title: '核心标签规则ID',
            dataIndex: 'tagCoreCode',
            key: 'tagCoreCode',
            align: 'center' as const,
        },
        {
            title: '商品品类',
            dataIndex: 'categoryName',
            key: 'categoryName',
            align: 'center' as const,
        },
        {
            title: '规则范围',
            dataIndex: 'attributeKeyCodesName',
            key: 'attributeKeyCodesName',
            align: 'center' as const,
        },
        {
            title: '执行状态',
            width: 100,
            dataIndex: 'processStatus',
            key: 'processStatus',
            render: (text: number) => {
                return text === 0 ? (
                    <Badge status="success" text="待处理" />
                ) : text === 1 ? (
                    <Badge status="error" text="处理中" />
                ) : (
                    <Badge status="processing" text="已处理" />
                );
            },
            align: 'center' as const,
        },
        {
            title: '更新人',
            dataIndex: 'updateByName',
            key: 'updateByName',
            align: 'center' as const,
        },
        {
            title: '更新时间',
            dataIndex: 'updateTime',
            key: 'updateTime',
            align: 'center' as const,
        },
        {
            title: '操作',
            align: 'center' as const,
            render: (_, record) => [
                <Button
                    size="small"
                    type="link"
                    onClick={() => {
                        services.navigation.goto(`/product/labelRule/detail/${record.tagCoreCode}`);
                    }}
                >
                    查看
                </Button>,
                record.processStatus !== 1 && (
                    <Button
                        size="small"
                        type="link"
                        onClick={() => {
                            services.navigation.goto(
                                `/product/labelRule/update/${record.tagCoreCode}`
                            );
                        }}
                    >
                        编辑
                    </Button>
                ),
                record.processStatus !== 1 && (
                    <Popconfirm
                        {...confirmProps}
                        onConfirm={() => {
                            api.get({}, { apiPath: `/searchTag/coreDelete/${record.tagCoreCode}` })
                                .then((res: any) => {
                                    if (res && res.resultCode === 200) {
                                        getList({ page: 1, per_page: pageSize });
                                    }
                                })
                                .catch(errorHandle);
                        }}
                    >
                        <Button size="small" type="link">
                            删除
                        </Button>
                    </Popconfirm>
                ),
            ],
        },
    ];
    const getCategoryCodeOptions = () => {
        api.get({ attr_code: 'ZHPPL', page: 1, per_page: 9999 }, { apiPath: '/attributes/options' })
            .then((res: any) => {
                if (res && res.result) {
                    setCategoryCodeOptions(res.result);
                }
            })
            .catch(errorHandle);
    };
    const getList = (data) => {
        api.get(data, { apiPath: '/searchTag/coreQueryPage' })
            .then((res: any) => {
                if (res && res.result) {
                    setTableData(res.result);
                    setPageNum(res.page);
                    setTotal(res.totalNum);
                }
            })
            .catch(errorHandle);
    };
    const handleSubmit = () => {
        form.validateFields((err, values) => {
            if (!err) {
                const params = {
                    ...values,
                    page: 1,
                    per_page: pageSize,
                    startUpdateTime:
                        values.updateTime && values.updateTime[0]
                            ? values.updateTime[0].format('YYYY-MM-DD')
                            : undefined,
                    endUpdateTime:
                        values.updateTime && values.updateTime[1]
                            ? values.updateTime[1].format('YYYY-MM-DD')
                            : undefined,
                };
                delete params.updateTime;
                setSearchParams(params);
                getList(params);
            }
        });
    };
    useEffect(() => {
        getCategoryCodeOptions();
        getList({ page: 1, per_page: pageSize });
    }, []);
    return (
        <>
            <Card>
                <Row>
                    <Form
                        layout="inline"
                        onSubmit={(e) => {
                            e.preventDefault();
                            handleSubmit();
                        }}
                    >
                        <Form.Item label="标签规则ID">
                            {form.getFieldDecorator(
                                'tagCoreCode',
                                {}
                            )(<Input placeholder="输入内容" />)}
                        </Form.Item>
                        <Form.Item label="商品品类">
                            {form.getFieldDecorator(
                                'categoryCode',
                                {}
                            )(
                                <Select
                                    placeholder="请选择"
                                    allowClear
                                    showSearch
                                    style={{ width: 250 }}
                                >
                                    {categoryCodeOptions.map((d) => (
                                        <Option key={d.optionCode} value={d.optionCode}>
                                            {d.optionName}
                                        </Option>
                                    ))}
                                </Select>
                            )}
                        </Form.Item>
                        <Form.Item label="更新人">
                            {form.getFieldDecorator(
                                'updateByName',
                                {}
                            )(<Input placeholder="输入内容" />)}
                        </Form.Item>
                        <Form.Item label="更新时间">
                            {form.getFieldDecorator(
                                'updateTime',
                                {}
                            )(<RangePicker placeholder={['开始时间', '结束时间']} />)}
                        </Form.Item>
                        <Form.Item>
                            <Button
                                type="primary"
                                style={{ marginRight: 8, marginBottom: 18 }}
                                htmlType="submit"
                            >
                                查询
                            </Button>
                            <Button onClick={() => form.resetFields()}>重置</Button>
                        </Form.Item>
                    </Form>
                </Row>
                <Row>
                    <Button
                        type="primary"
                        style={{ marginBottom: 18 }}
                        onClick={() => {
                            services.navigation.goto('/product/labelRule/add');
                        }}
                    >
                        新增标签规则
                    </Button>
                </Row>
                <Table
                    columns={columns}
                    dataSource={tableData}
                    pagination={{
                        total: total,
                        showSizeChanger: true,
                        showQuickJumper: true,
                        pageSizeOptions: ['10', '15', '20'],
                        pageSize: pageSize,
                        current: pageNum,
                        showTotal: (total, range) => `共 ${total} 条记录`,
                        onChange: (page) => {
                            getList({ ...searchParams, page, per_page: pageSize });
                        },
                        onShowSizeChange: (current, size) => {
                            setPageSize(size);
                            getList({ ...searchParams, page: current, per_page: size });
                        },
                    }}
                />
            </Card>
        </>
    );
};

export const labelRuleListView = Form.create()(LabelRuleListView);
